import { VoidDataType } from "~src/parser/c-ast/dataTypes";

export const voidDataType: VoidDataType = {
  type: "void",
};
